// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1Mk1y","paramInput":"JobSimulator_paramInput__2qJw1","input":"JobSimulator_input__20G79"};